import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const messagesApi = {
  getThreads: () => api.get('/messages/threads').then(unwrap),
  getMessages: (userId) => api.get(`/messages/${userId}`).then(unwrap),
  send: (data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData

    return api.post('/messages', data, isFormData
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : undefined).then(unwrap)
  },
  getTeachers: () => api.get('/messages/teachers').then(unwrap),
  getUsers: () => api.get('/messages/users').then(unwrap),
}
